import { Info } from 'lucide-react';
import * as React from 'react';


export interface InviteTeamNoteProps {
    basePrice: string | number;
    additionalSeatPrice: string;
    className?: string;
    currentInterval: string;
    userCount: number | string | undefined;
    plan?: string;
    teamPrice: string | number | undefined
}

export const InviteTeamNote: React.FC<InviteTeamNoteProps> = ({
    basePrice,
    additionalSeatPrice,
    currentInterval,
    userCount,
    plan,
    teamPrice
}) => {
    if (plan === 'free' || plan === 'trial') {
        return (
            <div className="text-textcolor my-6 flex gap-2 rounded-xl bg-gray-100 dark:bg-card px-4 py-3 text-sm">
                <Info size={18} />
                <div>
                    You're inviting <span className="font-bold">{userCount}</span>{' '}
                    team member{userCount === 1 ? '' : 's'}. Since you're on a{' '}
                    {plan === 'free' ? "free plan" : "trial plan"}
                    , you'll need to upgrade for{' '}
                    <span className="font-bold">
                        ${basePrice}
                    </span>{' '}
                    per {currentInterval}, plus{' '}
                    <span className="font-bold">
                        ${additionalSeatPrice}
                    </span>{' '}
                    per seat.
                </div>
            </div>
        )
    } else {
        return (
            <div className="text-textcolor my-6 flex gap-2 rounded-xl bg-gray-100 px-4 py-3 text-sm">
                <Info size={18} />
                <div>
                    You're inviting <span className="font-bold">{userCount}</span>{' '}
                    team member{userCount === 1 ? '' : 's'}. This'll add{' '}
                    <span className="font-bold">
                        ${teamPrice}
                    </span>{' '}
                    per {currentInterval} to your current plan.
                </div>
            </div>
        );

    }
};